/**
 * @license lucide v0.356.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const FileArchive = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M16 22h2a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v18" }],
    ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4" }],
    ["circle", { cx: "10", cy: "20", r: "2" }],
    ["path", { d: "M10 7V6" }],
    ["path", { d: "M10 12v-1" }],
    ["path", { d: "M10 18v-2" }]
  ]
];

export { FileArchive as default };
//# sourceMappingURL=file-archive.js.map
